export function isEnumValue(value: any, enumType: any): boolean {
  return Object.values(enumType).includes(value);
}
